import React from 'react';

/**
 * @param {import('./lib/propTypes').DividerProps} props
 */

const Divider = ({
  direction = 'horizontal',
  className = '',
  color = 'neutral-200',
  width = 'w-full',
  height = 'h-full'
}) => {
  const lineStyles =
    direction === 'horizontal' ? `h-[1px] ${width} bg-${color}` : `w-[1px] ${height} bg-${color}`;

  return <div className={`${lineStyles} ${className}`} />;
};

export default Divider;
